import { BonusDetails, IBonusDetailsItem } from '../components/main/FreeSpinsSwiss/types';

export const prepareMyPromotionBonusData = (
    bonuses: IBonusDetailsItem[],
    bonusDetails: BonusDetails) => bonuses.map((data: IBonusDetailsItem) => {
        const datailsData = bonusDetails?.[data.referenceId];
        const { gamingContext } = datailsData?.bonusTemplate || {};

        return {
            gamingContext,
            ...datailsData?.bonus,
            ...data,
            error: datailsData?.error || '',
            isLoading: datailsData?.isLoading || false
        };
    });
